import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import LitImage from './images/LitImage';

const AnyQuestions = () => {
  const data = imageQuery();
  return (
    <div className="any-questions">
      <div className="blueLinesSecondary">
        <LitImage image={data.yellowLinesLeft} />
      </div>
      <div className="any-questions-container">
        <div className="any-questions-header">
          <div className="blueLines">
            <LitImage image={data.yellowLinesLeft} />
          </div>

          <h3>Any questions?</h3>
          <div className="blueLines">
            <LitImage image={data.yellowLinesRight} />
          </div>
        </div>
        <p>
          We're straightforward, customer-obsessed and promise not to blind you
          with science. So go ahead, ask us anything.
        </p>
        <Link
          to="/contact-us"
          className="button"
          aria-label="Contact us"
          title="Contact us"
        >
          Contact us
        </Link>
      </div>{' '}
      <div className="blueLinesSecondary">
        <LitImage image={data.yellowLinesRight} />
      </div>
    </div>
  );
};

export default AnyQuestions;
const imageQuery = () =>
  useStaticQuery(graphql`
    query {
      yellowLinesLeft: file(
        relativePath: { eq: "home-images/anyQuestionsLinesLeftYellow.png" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      yellowLinesRight: file(
        relativePath: { eq: "home-images/anyQuestionsLinesRightYellow.png" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
    }
  `);
